"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardDropdownButton = exports.PrimaryDropdownButton = exports.NeutralDropdownWithBorderlessButton = exports.NeutralDropdownButton = exports.DropdownButton = exports.DestructiveDropdownButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _caretDown = require("../../../assets/icons/caret-down.svg");
var _dropdownButtonModule = _interopRequireDefault(require("./dropdown-button.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ButtonWithIcon = require("../button-with-icon/ButtonWithIcon");
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"];
var DropdownButton = function DropdownButton(_ref) {
  var children = _ref.children,
    options = _ref.options,
    prefixIcon = _ref.prefixIcon,
    onOptionClick = _ref.onOptionClick,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 'standard' : _ref$level,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
    _ref$showButtonForSin = _ref.showButtonForSingleOption,
    showButtonForSingleOption = _ref$showButtonForSin === void 0 ? false : _ref$showButtonForSin;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var buttonRef = (0, _react.useRef)(null);
  var listRef = (0, _react.useRef)(null);
  var handleClick = (0, _react.useCallback)(function () {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  }, []);
  var handleClickOutside = (0, _react.useCallback)(function (e) {
    if (isOpen && buttonRef.current && !buttonRef.current.contains(e.target) && listRef.current && !listRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
  if (showButtonForSingleOption && options.length === 1) {
    return /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.ButtonWithIcon, {
      level: level,
      prefixIcon: prefixIcon,
      onClick: function onClick() {
        return onOptionClick(options[0].key);
      }
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_dropdownButtonModule.default['dropdown-button'], className)
  }, /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.ButtonWithIcon, {
    level: level,
    prefixIcon: prefixIcon,
    suffixIcon: /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
      className: (0, _classnames.default)(_dropdownButtonModule.default['dropdown-button__icon'], _dropdownButtonModule.default["dropdown-button__icon--".concat(level)])
    }),
    innerRef: buttonRef,
    onClick: handleClick,
    className: (0, _classnames.default)(_dropdownButtonModule.default['dropdown-button__button'], buttonClassName)
  }, children), isOpen && /*#__PURE__*/_react.default.createElement("ul", {
    "data-testid": "dropdown-button-options",
    className: (0, _classnames.default)(_dropdownButtonModule.default['dropdown-button__options'], (0, _defineProperty2.default)({}, _dropdownButtonModule.default['dropdown-button__options--right-aligned'], alignment === 'right')),
    ref: listRef
  }, options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: o.key,
      className: _dropdownButtonModule.default['dropdown-button__option'],
      onClick: function onClick() {
        onOptionClick(o.key);
        setIsOpen(false);
      }
    }, o.label);
  })));
};
exports.DropdownButton = DropdownButton;
var PrimaryDropdownButton = function PrimaryDropdownButton(_ref2) {
  var children = _ref2.children,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(DropdownButton, Object.assign({
    level: "primary"
  }, rest), children);
};
exports.PrimaryDropdownButton = PrimaryDropdownButton;
var StandardDropdownButton = function StandardDropdownButton(_ref3) {
  var children = _ref3.children,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  return /*#__PURE__*/_react.default.createElement(DropdownButton, Object.assign({
    level: "standard"
  }, rest), children);
};
exports.StandardDropdownButton = StandardDropdownButton;
var NeutralDropdownButton = function NeutralDropdownButton(_ref4) {
  var children = _ref4.children,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded3);
  return /*#__PURE__*/_react.default.createElement(DropdownButton, Object.assign({
    level: "neutral"
  }, rest), children);
};
exports.NeutralDropdownButton = NeutralDropdownButton;
var NeutralDropdownWithBorderlessButton = function NeutralDropdownWithBorderlessButton(_ref5) {
  var children = _ref5.children,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded4);
  return /*#__PURE__*/_react.default.createElement(DropdownButton, Object.assign({
    level: "neutral-borderless"
  }, rest), children);
};
exports.NeutralDropdownWithBorderlessButton = NeutralDropdownWithBorderlessButton;
var DestructiveDropdownButton = function DestructiveDropdownButton(_ref6) {
  var children = _ref6.children,
    rest = (0, _objectWithoutProperties2.default)(_ref6, _excluded5);
  return /*#__PURE__*/_react.default.createElement(DropdownButton, Object.assign({
    level: "destructive"
  }, rest), children);
};
exports.DestructiveDropdownButton = DestructiveDropdownButton;